import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
export function InViewOnce({ children, rootMargin = '200px 0px', placeholder }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    const hasTriggeredRef = useRef(false);
    useEffect(()=>{
        // Ensure we only trigger visibility once
        if (visible || hasTriggeredRef.current) return;
        const el = ref.current;
        if (!el || typeof IntersectionObserver === 'undefined') {
            setVisible(true);
            hasTriggeredRef.current = true;
            return;
        }
        const io = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (e.isIntersecting && !hasTriggeredRef.current) {
                    hasTriggeredRef.current = true;
                    setVisible(true);
                    io.disconnect();
                    break;
                }
            }
        }, {
            root: null,
            rootMargin,
            threshold: 0.01
        });
        io.observe(el);
        return ()=>io.disconnect();
    }, [
        visible,
        rootMargin
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        children: visible ? children : placeholder ?? null
    });
}
export default InViewOnce;
